import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Overview } from './pages/Overview';
import { DemoModeManager } from './pages/DemoModeManager';
import { PipelineMonitor } from './pages/PipelineMonitor';
import { TriageAnalytics } from './pages/TriageAnalytics';
import { PersonaManager } from './pages/PersonaManager';
import { PricingTable } from './pages/PricingTable';
import { JurisdictionEditor } from './pages/JurisdictionEditor';
import { PromptLibrary } from './pages/PromptLibrary';
import { ReviewQueue } from './pages/ReviewQueue';
import { VoiceAnalytics } from './pages/VoiceAnalytics';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/overview" replace />} />
          <Route path="overview" element={<Overview />} />
          <Route path="demo" element={<DemoModeManager />} />
          <Route path="pipeline" element={<PipelineMonitor />} />
          <Route path="analytics" element={<TriageAnalytics />} />
          <Route path="personas" element={<PersonaManager />} />
          <Route path="pricing" element={<PricingTable />} />
          <Route path="jurisdictions" element={<JurisdictionEditor />} />
          <Route path="prompts" element={<PromptLibrary />} />
          <Route path="review-queue" element={<ReviewQueue />} />
          <Route path="voice" element={<VoiceAnalytics />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
